import { Component } from '@angular/core';

@Component({
  selector: 'app-stats-LH',
  templateUrl: './stats-LH.component.html',
  styleUrls: ['./stats-LH.component.scss']
})
export class StatsLHComponent {
}
